import { SpaceBetween, Button, Icon, Container, Header } from "@cloudscape-design/components"
import { helpPanelDefaultContent, useHelpPanel } from "contexts/HelpPanelContext";
import { useEffect } from "react";
import AppConfig from "configs/AppConfig";


function ContactPage() {

    const emailSupport = () => {
        window.location.href = "mailto:support@cloud-commit.com"
    }
    const { setHelpPanelContent } = useHelpPanel();
    
    useEffect(() => {
        setHelpPanelContent(helpPanelDefaultContent);
    }, [setHelpPanelContent]);

    return (
        <SpaceBetween direction="vertical" size="xl">

            <Header variant="h2">Contact</Header>

            <div className="contact-container">
                <SpaceBetween direction="vertical" size="l">
                    <Container>
                        <strong>Technical Support</strong>
                        <p>For technical support, please email us.</p>
                        <Button onClick={emailSupport}>
                            <SpaceBetween direction="horizontal" size="xxs" alignItems="center">
                                <Icon name="envelope" />
                                <span>support@cloud-commit.com</span>
                            </SpaceBetween>
                        </Button>
                    </Container>
                    <Container>
                        <strong>Bug Reports + Feature Requests</strong>
                        <p>Please file on Github issues or feature requests related to our open source projects.</p>
                        <Button href={AppConfig.FILE_AN_ISSUE} target="_blank" rel="noopener noreferrer">
                            <SpaceBetween direction="horizontal" size="xxs" alignItems="center">
                                <Icon name="bug" />
                                <span>File an issue</span>
                            </SpaceBetween>
                        </Button>
                    </Container>
                </SpaceBetween>
            </div>
        </SpaceBetween>
    )
}

export default ContactPage
